import { createSlice } from "@reduxjs/toolkit";
import { signOutAsync } from "../auth/auth.actions";
import {
  fetchFundRestructureChoicesThunk,
  fetchFundRestructureSourceDealThunk,
} from "./fundRestructure.actions";

interface FundRestructureAllocation {
  destinationDealId: string;
  noticePeriodMonths: number;
  label: string;
  amount: number;
  rateAtTimeOfChoice: number;
  loyaltyBoostAtTimeOfChoice: number | null;
  memberRateAtTimeOfChoice: number | null;
}

interface FundRestructureSubmission {
  allocations: FundRestructureAllocation[];
  incomeDecision: "WITHDRAW" | "REALLOCATE" | null;
  incomeReallocationDealId?: string;
  isMember: boolean;
}

export interface FundRestructureChoice {
  sourceCommitmentId: number;
  submission: FundRestructureSubmission;
  reallocationIds: string[] | null;
  isProcessed: boolean;
}

export interface FundRestructureChoiceState {
  choices: FundRestructureChoice[];
  loading: boolean;
  loaded: boolean;
  sourceDealMetadata: Record<string, unknown> | null;
  sourceDealLoaded: boolean;
}

const INITIAL_STATE: FundRestructureChoiceState = {
  choices: [],
  loading: false,
  loaded: false,
  sourceDealMetadata: null,
  sourceDealLoaded: false,
};

const fundRestructureSlice = createSlice({
  name: "fundRestructure",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(signOutAsync.fulfilled, () => INITIAL_STATE);

    builder.addCase(fetchFundRestructureChoicesThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchFundRestructureChoicesThunk.rejected, (state) => {
      state.loading = false;
      state.loaded = true;
    });
    builder.addCase(
      fetchFundRestructureChoicesThunk.fulfilled,
      (state, { payload }) => {
        state.choices = payload;
        state.loading = false;
        state.loaded = true;
      }
    );

    builder.addCase(
      fetchFundRestructureSourceDealThunk.fulfilled,
      (state, { payload }) => {
        state.sourceDealMetadata = payload;
        state.sourceDealLoaded = true;
      }
    );
    builder.addCase(fetchFundRestructureSourceDealThunk.rejected, (state) => {
      state.sourceDealLoaded = true;
    });
  },
});

export default fundRestructureSlice.reducer;
